import _head from 'lodash/head';
import _last from 'lodash/last';
import { decodeHtmlTitle } from 'services/api/products';
import IMG_DEFAULT_PRODUCT from 'assets/img/default_product.png';

export const transformProductData = (data) => {
  const mapDataToImages = ({ url, original, id, order }) => ({
    id: id || order,
    original: original || url,
    thumbnail: original || url,
    order: order || id
  });

  const images = data.images?.length ? data.images.map(mapDataToImages) : null;

  const productData = {
    ...data,
    image: images?.length ? images[0]?.original : IMG_DEFAULT_PRODUCT,
    c_descuento: data.discount,
    price: data.sale_price,
    msrp: data.price,
    title: decodeHtmlTitle(data.title),
    images
  };

  return productData;
};

export const transformCartProductList = (products, productsToMatch) => {
  const transformedProducts = products.map((product) => {
    const completedProduct =
      productsToMatch.find(
        (completeProduct) => completeProduct.id === product.product_sears_id
      ) || {};

    return {
      ...completedProduct,
      ...product
    };
  });

  return transformedProducts;
};

export const getListOfProductsIds = (products) =>
  products.map((gift) => gift.product_id || gift.id);

export const getListOfPrices = (productsPriceInfo) => {
  const DEFAULT = [0, 0];
  const PRICES_POSITION = 3;

  try {
    if (!productsPriceInfo || productsPriceInfo?.length === 0) return DEFAULT;

    const allPrices = productsPriceInfo[PRICES_POSITION];

    let newMinPrice = 0;
    let newMaxPrice = 0;

    if (Array.isArray(allPrices)) {
      const allMinPrice = allPrices.map((value) => value.MIN);
      const allMaxPrice = allPrices.map((value) => value.MAX);

      const orderMinPrice = allMinPrice?.sort((a, b) => a - b);
      const orderMaxPrice = allMaxPrice?.sort((a, b) => a - b);

      newMinPrice = Number(_head(orderMinPrice));
      newMaxPrice = Number(_last(orderMaxPrice));
    } else {
      newMinPrice = Number(allPrices.MIN);
      newMaxPrice = Number(allPrices.MAX);
    }

    return [newMinPrice, newMaxPrice];
  } catch (err) {
    console.error(err);
    return DEFAULT;
  }
};
